import { message } from "antd";
import {
  AppointmentTimeSlotPlanFormCard,
  AppointmentTimeSlotPlanFormValues,
} from "./components/AppointmentTimeSlotPlanForm";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createAppointmentTimeSlotPlan } from "../../../../lib/api/resources/appointmentTimeSlotPlans";
import { useNavigate } from "react-router-dom";

export const AppointmentTimeSlotPlanCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createAppointmentTimeSlotPlanMutation = useMutation({
    mutationFn: (data: AppointmentTimeSlotPlanFormValues) =>
      createAppointmentTimeSlotPlan(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["appointmentTimeSlotPlans"] });
      message.success("Planning succesvol aangemaakt");
      navigate("/appointment-time-slots/plans");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het aanmaken van de planning",
      ),
  });

  return (
    <AppointmentTimeSlotPlanFormCard
      mutation={createAppointmentTimeSlotPlanMutation}
    />
  );
};
